import translations from './translations.json';
const en = { choose: 'Choose your language', continue: 'Continue', error: 'Could not save the language. Please try again.' };
export const onboardingCopy = language => translations[String(language).toLowerCase().split(/[-_]/)[0]] || en;
export function translateLesson(lesson, language, signedIn = false) {
  const copy = onboardingCopy(language), translated = copy.lessons?.[lesson.step - 1];
  if (!translated) return { ...lesson, paragraphs: lesson.paragraphs.map((text, index) =>
    (signedIn && lesson.signedInCopy?.[index]) || text) };
  const body = [...translated.paragraphs];
  if (signedIn && translated.signedIn) body[0] = translated.signedIn;
  return { ...lesson, title: translated.title, paragraphs: [copy.step.replace('{step}', lesson.step), '',
    ...body.flatMap((text, index) => index === body.length - 1 ? [text] : [text, ''])] };
}
